'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    aggregationType: 'SUM',
    valueType: 'NUMBER'
};
//# sourceMappingURL=dataElement.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2/lib/model/config/model-defaults/dataElement.js
// module id = 662
// module chunks = 0